module.exports = __webpack_public_path__ + "img/transfer_rekening.51c2346d.png";